export default function getSections(data, code) {
    if (!data || !data.hasOwnProperty(code)) {
        return null;
    }

    const course = data[code];
    if (!course || !course.sections || !Array.isArray(course.sections)) {
        console.warn(`getSections: No valid sections for ${code}`);
        return null;
    }

    const { sections } = course;

    const ret = {};
    sections.forEach(section => {
        if (!section || !section.section) {
            console.warn(`getSections: Invalid section in ${code}`, section);
            return; // skip this iteration
        }

        const match = section.section.match(/[A-Za-z]+/i);
        if (!match || !match[0]) {
            console.warn(`getSections: Could not parse section type from ${section.section}`);
            return; // skip this iteration
        }

        const type = match[0];

        if (!(type in ret)) {
            ret[type] = [];
        }

        let isDuplicate = false;
        for (let j = 0; j < ret[type].length; j++) {
            if (section.section === ret[type][j]) {
                isDuplicate = true;
            }
        }

        if (!isDuplicate) {
            ret[type].push(section.section);
        }
    });

    return ret;
}
